import { GetterTree } from 'vuex'
import { IChatNewState } from './types'
import ChatRoom from '@/models-ts/chat/ChatRoom'

export default {
  getRoomMessages: (state) => {
    if (state.openedRoomId) {
      return state.messages[state.openedRoomId]?.value || []
    }
    return []
  },
  getRoomMessageLoading: (state) => {
    if (state.openedRoomId) {
      return state.messages[state.openedRoomId]?.isLoading
    }
    return true
  },
  getParticipant: (state) => (id: string) => state.participants[id],
  getOpenedRoom: (state) => {
    if (state.openedRoomId) {
      return state.openedRooms[state.openedRoomId]
    }
  },
  getUnreadCount: (state) => (id: ChatRoom['id']) => {
    return state.unreadMap[id] || 0
  },
  formattedUnreadCount: (state) => {
    const values: number[] = Object.values(state.unreadMap)
    const unreadMsgs = values.reduce((acc: number, cur: number) => {
      if (!cur) return acc

      return acc + cur
    }, 0)
    return unreadMsgs >= 99 ? '99+' : unreadMsgs
  },
} as GetterTree<IChatNewState, any>
